var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAccept = function SvgAccept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008E00",
    fillRule: "evenodd",
    d: "M20 0c11.035 0 20 8.965 20 20s-8.965 20-20 20S0 31.035 0 20 8.965 0 20 0zm7.027 12.838a.66.66 0 00-.934 0l-8.912 8.911-4.222-4.222a.66.66 0 00-.933 0L9.833 19.72a.66.66 0 000 .933l6.882 6.882.074.064a.66.66 0 00.86-.064l11.57-11.57a.66.66 0 000-.934z"
  })));
};
export default __webpack_public_path__ + "static/media/accept.49f09f38.svg";
export { SvgAccept as ReactComponent };